import { Injectable } from '@angular/core';
import { BaseService } from '../../../../shared/services/base.service';
import { MasterDataUrl } from '../../../../shared/urls/master-data.urls'
import { Utility } from '../../../../common/utility';
import { PatientUrl } from '../../../../shared/urls/patient.url'

@Injectable()
export class PatientInformationCopyService {
    constructor(public baseService: BaseService) {
    }

    getPatientDetail(id) {
      const url = PatientUrl.GET_PATIENT_ACCOUNT.replace('{id}', id);
      return this.baseService.getData(url);
    }

    export(id, style) {
      const url = Utility.stringFormat(PatientUrl.EXPORT_TO_CSV, [id, style]);
      return this.baseService.export(url);
  }
}




// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/centre/manage-patient-user/patient-infomation-copy/patient-infomation-copy.service.ts